<template>
  <!-- <img alt="Vue logo" class="top-img" src="./assets/images/top.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <div class="app-container">
    <router-view />
  </div>

</template>

<script>
import HelloWorld from './components/HelloWorld.vue'


export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
.app-container {
  width: 100%;
  min-height: 100vh;
}

::-webkit-scrollbar {
  width: 0px;
}

.top-img {
  width: 100%;
  height: 100%;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  scroll-behavior: smooth;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

</style>
